import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import axios from 'axios'

import { TiptapVuetifyPlugin } from "tiptap-vuetify";
// don't forget to import CSS styles
import 'tiptap-vuetify/dist/main.css'
// Vuetify's CSS styles 
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.config.productionTip = false
Vue.prototype.http = axios

Vue.use(vuetify);
Vue.use(TiptapVuetifyPlugin, {
  vuetify
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
